/*------------------------------------*\
    #SCROLL-EVENTS 
\*------------------------------------*/

WW.scrollEvents = function($, ...funcs) {
    'use strict';
    let previousOffset = window.pageYOffset;
    const loop = () =>{
        let currentOffset;
        currentOffset = window.pageYOffset;
        if (currentOffset === previousOffset) {
            requestAnimationFrame(loop);
            return false;
        } else {
            previousOffset = currentOffset;
        }
        funcs.forEach((func) => {
            func($);
        });

        requestAnimationFrame(loop);
    };
    // Call the loop for the first time
    requestAnimationFrame(loop);

    return this;
};